// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609070421/js/" + chunkId + "." + {"44":"c34b9142","225":"f48e6a60","481":"7f861a49","486":"08321d18","770":"fa637a24"}[chunkId] + ".0.9848768526760139.chunk.js";
};